import React, { useEffect, useState, useRef } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { useMediaQuery } from 'react-responsive'
import { Routes, Route, useNavigate, useParams } from "react-router-dom";
import { Debug, Menu, MenuTop, LoadLogin, LoadUser, Loading, UserData, SalonData, AlertDialog, SalonSettings, ShowOK, Empty, GetLanguage, AgentChoose, BannerImage, LoadToken, DialogHelp } from './items.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme2-6.css";
import { styles } from './styles.js';
import { Booking } from './booking.js';
import { BookingHistory } from './booking_history.js';
import { Button } from '@mui/material';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './items.css';
import { Rules } from './rules.js';


export const Main = (props) => {
    const navigate = useNavigate();

    // LANGUAGE
    const [language, setLanguage] = useState(0);

    // APP
    const [isBusy, setBusy] = useState(true);
    const [isLoading, setLoading] = useState(true);
    const [redraw, setRedraw] = useState(true);

    // REGISTER - WELCOME
    const [register, setRegister] = useState(false);
    const [welcome, setWelcome] = useState(false);

    // ALERT DIALOG - VYPNUTY UCET
    const [showAlert, setShowAlert] = useState(false);

    // OK
    const [showOK, setShowOK] = useState(false);

    // prihlásený užívazeľ
    const [logged, setLogged] = useState(false);
    const [user, setUser] = useState(null);
    const [userTyp, setUserTyp] = useState(0);
    const [label, setLabel] = useState('');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [email, setEmail] = useState('');
    const [showUser, setShowUser] = useState(false);
    const [company, setCompany] = useState([]);

    // REKLAMA
    const [banner, setBanner] = useState(false);
    const [ads, setAds] = useState(false);
    const [newsletter, setNewsletter] = useState(false);

    const [showAgents, setShowAgents] = useState(false);
    const [bodyID, setBodyID] = useState(0);
    const [year, setYear] = useState('2022');
    const [showHelp, setShowHelp] = useState(false);

    // GDPR, ....
    const [showRules, setShowRules] = useState(false);

    const isLarge = useMediaQuery({ minWidth: global.device_medium + 1 });
    const isMedium = useMediaQuery({ minWidth: global.device_small + 1, maxWidth: global.device_medium });
    const isSmall = useMediaQuery({ maxWidth: global.device_small });

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    var lang = GetLanguage(language);
    var timer = null;
    const homeRef = useRef(null)

    const bottomHeight = 35
    //const logo = require('./react/app/logo.png');


    useEffect(() => {

        var need_register = false;

        // RELOAD PAGE - AK SA ZMENI VELKOST OKNA        
        function handleResize() {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setWidth(window.innerWidth);
                setHeight(window.innerHeight);
            }, 500);
        }
        if (isLarge == true) {
            window.addEventListener('resize', handleResize);
        }

        var now = new Date();
        var year_ = now.getFullYear();
        setYear(year_);

        // KONTROLA PRIHLASENIA
        var token = LoadToken();

        if (token == null) {
            navigate("/login");
        } else {
            db_token_check(token)
        }
        /*
        var user_id = 0;

        if (data != null) {
            if (data.logged == true) {
                setLogged(true);
                var user = LoadUser();
                user_id = user.id;
                setUser(user);
                setName(user.name);
                setSurname(user.surname);
                setEmail(user.email);

                // TYP SALON / AGENT / ADMIN -> ZMENI MENU                
                setUserTyp(user.typ);

                // zmena jazyka
                setLanguage(GetLanguage(user.language));
                SaveLanguage(user.language);

                if (user.typ == 2 && (user.company == null || user.company == '')) {
                    // REGISTRACIA - WELCOME
                    setRegister(true);
                    setWelcome(true);
                    need_register = true;
                } else {
                    setCompany(user.salon_name);
                }
            } else {
                navigate('/login');
            }
        }
        setLabel(lang.admin);

        if (need_register == false) {
            db_web(user_id);
            setLoading(false);
        } else {
            setLoading(false);
            setBusy(false);
        }
        */


        return () => {
        };

    }, []);

    const db_web = async (id) => {
        // AKTUALIZACIA UDAJOV

        setBusy(true);

        try {
            const response = await fetch(
                global.db_url + 'web', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: id,
                    language: lang.lang_id
                })
            })

            const json = await response.json();
            
            if (json.ok > 0) {
                var salon = json.salon;
                setUser(salon);
                setUserTyp(salon.typ);
                setLanguage(salon.language);

                if (salon.enabled == false) {
                    setShowAlert(true);
                }

                if (salon.typ == 2) {
                    if (salon.agent_id == 0 || salon.agent_id == null) {
                        setShowAgents(true);
                    }
                }

                setBanner(json.banner);
                setAds(json.ads);
                setNewsletter(json.newsletter);
            }
            setBusy(false);

        } catch (error) {
            Debug(error);
            setBusy(false);
        }
    }

    const db_token_check = async (token) => {

        setBusy(true);

        try {
            const response = await fetch(
                global.db_url + 'token_check', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                })
            })

            const json = await response.json();
            if (json.ok > 0) {
                var user = json.user;
                setUser(user);
                setLanguage(user.language);
                setName(user.name);
                setSurname(user.surname);
                setEmail(user.email);
                setLanguage(GetLanguage(user.language));

                setUserTyp(user.typ);
                setLogged(true);

                if (user.enabled == false) {
                    setShowAlert(true);
                }

                if (user.agent_id == 0 || user.agent_id == null) {
                    setShowAgents(true);
                }

                if (user.company == null || user.company == '') {
                    // REGISTRACIA - WELCOME
                    setRegister(true);
                    setWelcome(true);

                } else {
                    setCompany(user.salon_name);
                }

                db_web(user.id);

            }
            setBusy(false);

        } catch (error) {
            Debug(error);
            setBusy(false);
        }
    }

    const MenuPress = (id, children_id, item) => {
        if (id != 0) {
            var menu_id = parseInt(id * 1000) + parseInt(children_id);

            var menu = lang.menuitems.find(x => parseInt(x.id) == id);
            var submenu = menu.children.find(x => parseInt(x.id) == children_id)

            setLabel(submenu.label);
            setBodyID(menu_id);
        } else {
            setLabel(lang.admin);
            setBodyID(0);
        }
    }


    const MenuTopPress = (typ, children_id, item) => {
        if (typ == 999) {
            // ADMINISTRATOR - UDAJE
            setShowUser(true);
        }
        else {
            // stlacene menu-button
            MenuPress(typ, children_id, item);
        }
    }

    const UserDataPress = (typ, data) => {
        if (typ == false) {
            setShowUser(false);
        }
        if (typ == true) {
            var tmp = user;
            tmp.name = data.name;
            tmp.surname = data.surname;
            tmp.username = data.username;
            setEmail(data.username);
            setName(data.name);
            setSurname(data.surname);
            setShowUser(false);
        }

    }

    const SalonDataResult = (data) => {
        setUser(data);
        setCompany(data.salon_name);
        setEmail(data.email);
        setName(data.name);
        setSurname(data.surname);
        setLanguage(GetLanguage(user.language));
        setWelcome(false);
        setShowAgents(true);
    }

    const AlertDialogResult = () => {
        navigate('/logout');
    }

    const SalonSettingsResult = (id, data) => {
        if (id == true) {
            /*
            setUser(data);
            setCompany(data.salon_name);
            setEmail(data.email);
            setName(data.name);
            setSurname(data.surname);
            */
            var token = LoadToken();
            if (token != null) {
                db_token_check(token);
            }
            setShowOK(true);
        }
        setLabel('');
        setBodyID(0);

    }

    const ShowOKPress = (value) => {
        setShowOK(false);
    }

    const AgentChooseResult = (id) => {
        var data = user;
        data.agent_id = id;

        setUser(data);
        setShowAgents(false);
    }

    const DialogHelpResult = (value) => {
        setShowHelp(false)
    }

    const RulesResult = () => {
        setShowRules(false);
    }

    return (

        <div>
            <div style={{ ...isSmall ? styles.Block : styles.BlockRow, backgroundColor: global.theme_back, width: isSmall ? undefined : width, height: isSmall ? undefined : height }}>
                {isSmall ? null :
                    <Menu lang={lang} typ={userTyp} menu_id={bodyID} company={company} height={height} email={email} func={MenuPress.bind(this)} />
                }
                <div style={{ ...styles.Block }}>
                    <MenuTop lang={lang} typ={userTyp} menu_id={bodyID} company={company} height={height} label={label} name={name} surname={surname} email={email} search={false} func={MenuTopPress.bind(this)} />

                    {/* BODY */}
                    <div style={{ ...styles.BlockCenter, width: '100%', height: isSmall ? undefined : height - 72 - bottomHeight, msOverflowStyle: 'none', scrollbarWidth: 'none', overflowY: 'scroll' }} className='container'>

                        {/* MAIN BODY - HOME */}
                        {bodyID == 0 ?
                            <div style={{ ...styles.Block, paddingTop: 0, paddingBottom: 0 }}>
                                <div style={{ ...styles.Block, paddingTop: 0 }}>
                                    {banner != false ?
                                        <BannerImage banner={banner} full={ads} />
                                        : null}
                                    {newsletter != false ?
                                        <a href={global.ads + '/pdf/' + newsletter.link} target="_blank" style={{ ...styles.BlockRow, justifyContent: 'center', paddingTop: 10, paddingBottom: 10, backgroundColor: newsletter.color, textDecoration: 'none' }}>
                                            <img src={global.ads + '/pdf/' + newsletter.image} style={{ width: 50, borderRadius: 5 }}></img>
                                            <p style={{ ...isSmall ? styles.TextNormal : styles.TextXLarge, marginTop: isSmall ? 14 : 10, marginLeft: 10 }}><b>{lang.newsletter}</b>{isSmall ? '' : ' - ' + lang.newsletter_text}</p>
                                        </a>
                                        : null}
                                    <div style={{ ...styles.Block, height: 150 }}>
                                        <img src={global.images + 'app/logo_ie.png'} style={{ width: 200 }}></img>
                                    </div>

                                    {/*
                                        <Button onClick={() => MenuPress(1, 1)} style={{ ...styles.ButtonDashboard, margin: 20, backgroundColor: global.theme_green }} >
                                            <FontAwesomeIcon style={{ width: 22, height: 22, color: global.theme_white }} icon={faEdit} />
                                            <p style={{ ...styles.TextSmall, color: global.theme_white, marginTop: 5 }}>{lang.ziadost_new}</p>
                                        </Button>
                                        */}

                                </div>
                            </div>
                            : null}

                        {/* OBCHOD */}
                        {bodyID == 1011 ?
                            <div style={{ ...styles.Block, paddingBottom: 20 }}>
                                <Booking language={lang} user={user} />
                            </div>
                            : null}
                        {bodyID == 1012 ?
                            <div style={{ ...styles.Block, paddingBottom: 20 }}>
                                <BookingHistory language={lang} user={user} />
                            </div>
                            : null}

                        {/* NASTAVENIA */}
                        {bodyID == 2021 ?
                            <div style={{ ...styles.Block, paddingBottom: 20 }}>
                                <SalonSettings language={lang} user={user} func={SalonSettingsResult.bind(this)} />
                            </div>
                            : null}
                    </div>

                    <div style={{ ...isSmall ? styles.Block : styles.BlockRow, backgroundColor: global.theme_lighter }}>
                        <div style={{ ...isSmall ? styles.Block : styles.BlockLeft, height: bottomHeight, justifyContent: 'center' }}>
                            <a href='https://datadream.sk' style={{ margin: 0, color: global.theme_dark_gray, fontSize: global.font_tiny, textDecoration: 'none', marginLeft: 10 }}>© {lang.copyright} {year} - {global.creator}</a>
                        </div>
                        <div style={{ ...styles.Block, height: bottomHeight }}>
                            <Button onClick={() => setShowHelp(true)} style={{ ...styles.ButtonLink, color: global.theme_dark_gray }}>{lang.help}</Button>
                        </div>
                        <div style={{ ...styles.Block, height: bottomHeight }}>
                            <Button onClick={() => setShowRules(true)} style={{ ...styles.ButtonLink, color: global.theme_dark_gray }}>{isLarge ? lang.gdpr : lang.gdpr_}</Button>
                        </div>
                        <div style={{ ...isSmall ? styles.Block : styles.BlockRight, height: bottomHeight, justifyContent:'center' }}>
                            <a href='https://app.esthedermsalon.com/public/pdf/navod_sk.pdf' target={'_blank'} style={{ margin: 0, color: global.theme_dark_gray, fontSize: global.font_tiny, textDecoration: 'none', marginRight:isSmall ? 0 : 20 }}>
                                {isSmall ?
                                    <p style={{ ...styles.TextTiny, color: global.theme_dark_gray }}>{lang.helper}</p>
                                    :
                                    <FontAwesomeIcon style={{ height: bottomHeight - 10, color: global.theme_dark }} icon={faQuestionCircle} />
                                }
                            </a>
                        </div>
                    </div>
                </div>

                {showUser == true ?
                    <UserData language={lang} user={user} func={UserDataPress.bind(this)} />
                    : null}

            </div >

            {welcome == true ?
                <SalonData language={lang} user={user} register={register} func={SalonDataResult.bind(this)} />
                : null}

            {showAlert == true ?
                <AlertDialog label={lang.disabled_label} info={lang.disabled_info} text={lang.disabled_text} button_text={lang.disabled_button} button_color='' func={AlertDialogResult.bind(this)} />
                : null}

            {showAgents == true ?
                <AgentChoose user={user} func={AgentChooseResult.bind(this)} />
                : null}

            {showOK == true ?
                <ShowOK func={ShowOKPress.bind(this)} />
                : null}

            {showHelp == true ?
                <DialogHelp user={user} lang={lang} func={DialogHelpResult.bind(this)} />
                : null}

            {showRules == true ?
                <Rules title={lang.gdpr} lang={lang} typ={1} salon_id={2} language={language} func={RulesResult.bind(this)} />
                : null}

            {isBusy ?
                <Loading />
                : null}

        </div >
    )
};

